$('#slider3d').slick({
	infinite: true,
	slidesToShow: 3,
	slidesToScroll: 1,
	rtl: ($("html").attr('dir') == 'rtl' ? true : false),
	dots: false,
	speed: 500,
	arrows: true,
	autoplay: false,
	autoplaySpeed: 6000,
	cssEase: 'linear',
	pauseOnHover: false,
	appendArrows: $(".slider3d-block-wrap"),
	prevArrow: $(".arr-right"),
	nextArrow: $(".arr-left"),
	centerMode: true,
	centerPadding: '10px',
	focusOnSelect: true,
	responsive: [{
		breakpoint: 992,
		settings: {
			slidesToShow: 2,
			slidesToScroll: 1,
			centerMode: false,
			centerPadding: '0',
		}
	}, {
		breakpoint: 600,
		settings: {
			slidesToShow: 1,
			slidesToScroll: 1,
			centerMode: false,
			centerPadding: '0',
		}
	}, ]
});